import { render, staticRenderFns } from "./RequestFooter.vue?vue&type=template&id=3d2d477b&"
import script from "./RequestFooter.vue?vue&type=script&lang=js&"
export * from "./RequestFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports